import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    if (trend === 'new') return 'ri-sparkling-line text-accent-500';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">热门榜单</h2>
        <p className="section-subtitle">实时热度排行，发现大家都在追的爆款好剧</p>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 border-b border-background-200/50 last:border-b-0 group cursor-pointer hover:bg-background-50/50 px-3 -mx-3 rounded-md transition-colors"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1 text-sm font-semibold text-primary-600">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat}
                </div>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={getTrendIcon(item.trend)}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}